import { useState } from 'react';

// simple in‑memory token hook for the front app; persistence is not needed
function useToken() {
  const [token, setToken] = useState(null);

  const saveToken = (userToken) => {
    setToken(userToken);
  };

  const removeToken = () => {
    setToken(null);
  };

  return {
    setToken: saveToken,
    token,
    removeToken,
  };
}

export default useToken;
